import { db} from "./firebase.config";
import {collection,addDoc} from "firebase/firestore"
export default async function enviarCorreo (email,subject,body){
    const disableEmails = process.env.REACT_APP_DISABLE_EMAILS === 'true';
    if (disableEmails) {
        console.warn('Emails disabled for testing.', { email, subject });
        return Promise.resolve({ disabled: true });
    }
    const collectionRef = collection(db,'mail');
    const emailContent={
        to: email,
        message: {
            subject: subject,
            text: body,
            html: `<p>${body}</p>`

        }
        
    };
    return await addDoc(collectionRef,emailContent);
}